@if (visible()) {
  <div class="terms-overlay">
    <div
      class="terms-card"
      role="dialog"
      aria-modal="true"
      aria-labelledby="terms-title"
      kirigamiModalFocus
      (escapePressed)="onEscapePressed()"
    >
      <h2 id="terms-title" class="terms-title">Terms &amp; Conditions</h2>
      <p class="terms-intro">
        Please review and accept our Terms &amp; Conditions to continue using Kirigami.
      </p>

      <iframe
        class="terms-frame"
        src="terms-and-conditions.html?embed=1"
        title="Terms and Conditions"
      ></iframe>

      <label class="terms-agree">
        <input
          type="checkbox"
          [checked]="agreed()"
          (change)="setAgreed($any($event.target).checked)"
        />
        I have read and agree to the Terms &amp; Conditions
      </label>

      @if (error()) {
        <p class="terms-error" role="alert">{{ error() }}</p>
      }

      <div class="terms-actions">
        <kirigami-button
          type="button"
          label="Decline"
          color="secondary"
          size="small"
          [filled]="false"
          (onClick)="decline()"
        ></kirigami-button>
        <kirigami-button
          type="button"
          label="Accept"
          color="primary"
          size="small"
          [filled]="true"
          [disabled]="!agreed() || submitting()"
          [loading]="submitting()"
          (onClick)="accept()"
        ></kirigami-button>
      </div>
    </div>
  </div>
}
